/*
 * @Author: yeyimei
 * @Date: 2023-09-20 18:09:24
 * @LastEditTime: 2023-12-08 18:32:45
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\movie.routes.js
 */
export default [
  // {
  //   path: "/movie",
  //   name: "movie",
  //   component: () =>
  //     import(
  //       /*webpackChunkName: 'home'*/ "@/views/movie/components/parentCpn/index.vue"
  //     ),
  //   redirect: "/movie/home",
  //   children: [
  //     {
  //       path: "home",
  //       name: "movieHome",
  //       component: () => import("@/views/movie/index.vue"),
  //       meta: {
  //         title: "特惠电影票",
  //         showName: true,

  //       },
  //     },
  //     {
  //       path: "cinema",
  //       name: "movieCinema",
  //       component: () =>
  //         import(/* webpackChunkName: 'classify' */ "@/views/movie/cinema.vue"),

  //       meta: {
  //         title: "影院",

  //       },
  //     },
  //     {
  //       path: "points-mall/home",
  //       name: "moviePointsmall",
  //       component: () => import("@/views/points-mall/index.vue"),
  //       meta: {
  //         title: "积分中心",
  //         showName: true,
  //       },
  //     },
  //     {
  //       path: "order-list",
  //       name: "movieOrderList",
  //       component: () => import("@/views/movie/order-list.vue"),
  //       meta: {
  //         title: "订单",

  //       },
  //     },
  //     {
  //       path: "mine",
  //       name: "movieMine",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: 'mine' */
  //           "@/views/mine/index.vue"
  //         ),
  //       meta: {
  //         title: "我的",

  //       },
  //     },
  //   ],
  // },
  {
    path: "/movie/home",
    name: "movieHome",
    component: () => import("@/views/movie/index.vue"),
    meta: {
      title: "特惠电影票",
      showName: true,
      isMovieTabBar: true

    },
  },
  {
    path: "/movie/cinema",
    name: "movieCinema",
    component: () =>
      import(/* webpackChunkName: "classify" */ "@/views/movie/cinema.vue"),

    meta: {
      title: "影院",
      isMovieTabBar: true

    },
  },
  {
    path: "/movie/points-mall/home",
    name: "moviePointsmall",
    component: () => import("@/views/points-mall/index.vue"),
    meta: {
      title: "绿色积分中心",
      showName: true,
    },
  },
  {
    path: "/movie/order-list",
    name: "movieOrderList",
    component: () => import("@/views/movie/order-list.vue"),
    meta: {
      title: "订单",
      isMovieTabBar: true

    },
  },
  {
    path: "/movie/mine",
    name: "movieMine",
    component: () =>
      import(
        /* webpackChunkName: "mine" */
        "@/views/mine/index.vue"
      ),
    meta: {
      title: "我的",
      isMovieTabBar: true

    },
  },
  {
    path: "/movie/movie-search",
    name: "movieSearch",
    component: () => import("@/views/movie/movie-search.vue"),
    meta: {
      title: "搜索",
      keepAlive: true,
    },
  },
  {
    path: "/movie/cinema-search",
    name: "movieCinemaSearch",
    component: () => import("@/views/movie/cinema-search.vue"),
    meta: {
      title: "搜索",
      keepAlive: true,
    },
  },
  {
    path: "/movie/film-cinema",
    name: "movieFilmCinema",
    component: () => import("@/views/movie/film-cinema.vue"),
    meta: {
      title: "影片",
      keepAlive: true,
    },
  },
  {
    path: "/movie/cinema-film",
    name: "movieCinemaFilm",
    component: () => import("@/views/movie/cinema-film.vue"),
    meta: {
      title: "电影",
      keepAlive: true,
    },
  },
  {
    path: "/movie/seat",
    name: "movieSeat",
    component: () => import("@/views/movie/seat.vue"),
    meta: {
      title: "选座",
      keepAlive: true,
    },
  },
  {
    path: "/movie/confirm-order",
    name: "movieConfirmOrder",
    component: () => import("@/views/movie/confirm-order.vue"),
    meta: {
      title: "确认订单",
      keepAlive: true,
    },
  },
  {
    path: "/movie/order-detail",
    name: "movieOrderDetail",
    component: () => import("@/views/movie/order-detail.vue"),
    meta: {
      title: "影票详情",
      // keepAlive: true,
    },
  },
  {
    path: "/movie/movie-detail",
    name: "movieDetail",
    component: () => import("@/views/movie/movie-detail.vue"),
    meta: {
      title: "影片详情",
      keepAlive: true,
    },
  },
]
